// remember to update confluence page after modifying this file
// https://dop-orange.atlassian.net/wiki/spaces/WUWA/pages/1827602540/Nju+Tagging+DataLayer

import { IProduct } from "./types";

type IPurchaseAdditionalPackageProps = {
  products: IProduct[];
};

export function pushPurchaseAdditionalPackageEvent({
  products,
}: IPurchaseAdditionalPackageProps) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        purchase: {
          actionField: {
            step: 1,
            action: "purchase",
          },
          products,
        },
      },
      pageType: "eshop",
    });
  }
}
